import { get } from '@/admin/services/api/http-utils';

export default {
  state: {
    paymentTypes: [],
  },
  mutations: {
    setPaymentTypes(state, data) {
      state.paymentTypes = data;
    },
  },
  actions: {
    async fetchPaymentTypes({ commit }) {
      const { data } = await get('/admin/payment-type');
      commit('setPaymentTypes', data.data);
    },
  },
  getters: {},
};
